import { useLocation, useNavigate } from "react-router-dom";
import Logo from '../svgs/TgatherLogoSvg';
import { useEffect, useState } from "react";
import { fetchEvents } from "../services/events";

export default function Page() {

    const [events, setevents] = useState([]);

    async function fetchData() {
        let result = await fetchEvents({ status: 'published' },{limit: 100, skip: 0,sort:{order:-1}});
        if (result.errno === 0) {
            setevents(result.result);
        }
    }
    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="w-full h-full flex flex-col items-center justify-start bg-[#ddd] overflow-hidden">

            <div className="w-full h-full flex-col flex items-center" style={{ overflow: 'auto', boxSizing: "border-box" }}>
                <div className="w-full max-w-[800px] flex flex-col items-center justify-start py-[40px] px-[20px] box-border">
                    <div className="w-full text-[32px] font-bold text-center mb-[20px]">
                        活動一覽
                    </div>
                    <div className="w-full flex flex-col items-center justify-start gap-[20px]">
                        {events.map((event, index) => (
                            <div key={index} className="w-full bg-white rounded-[8px] shadow-md overflow-hidden flex flex-col">
                                <div className="w-full h-auto overflow-hidden">
                                    <img src={event.preview} alt={event.title} className="w-full h-full object-cover" />
                                </div>
                                <div className="flex-1 p-[16px] flex flex-col justify-between">
                                    <div>
                                        <div className="text-[20px] font-bold mb-[8px]">{event.name}</div>
                                        <div className="text-[14px] text-[#555] mb-[12px]">{event.subtitle}</div>
                                        <div className="text-[16px] text-[#333] mb-[12px]">{event.location}</div>
                                        <div className="text-[16px] text-[#333] mb-[12px]">{event.time}</div>
                                        <div className="text-[16px] text-[#333] mb-[12px]">{event.date}</div>
                                    </div>
                                    <div className="flex justify-end">
                                        <a href={`https://tgather.net/articles/events/${event._id}`} className="text-[#fff] bg-[#938474] px-[12px] py-[8px] rounded hover:bg-[#7a6a5c]">查看詳情</a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}